<template>
  <unicom-linha :espacamento="false">
    <unicom-coluna sm="12" style="padding-bottom: 24px">
      <div class="titulo negrito cor-fonte fonte-primaria">
        Solicitação: <span class="cor-principal"> Exclusão </span>
      </div>
      <div
        class="medio segunda-cor-fonte"
        style="padding-top: 12px"
        v-if="mostrarArquivoRecebido"
      >
        Uma solicitação de exclusão foi encaminhada. Analise o arquivo contendo
        a justificativa da solicitação
      </div>
    </unicom-coluna>
    <unicom-coluna>
      <JustificativaVazia
        v-if="mostrarJustificativaVazia"
        @redirecionar="redirecionar"
      />
      <ArquivoRecebido
        v-else-if="mostrarArquivoRecebido"
        :informacoesArquivo="listaArquivos[0]"
        @aprovar-arquivo="aprovarArquivo"
        @reprovar-arquivo="reprovarArquivo"
        @baixar-arquivo="uuid => $emit('baixar-arquivo', uuid)"
      />
      <ListaArquivos
        @baixar-arquivo="uuid => $emit('baixar-arquivo', uuid)"
        :listaArquivos="listaArquivosComputed"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import JustificativaVazia from "./componentes/JustificativaVazia/JustificativaVazia";
import ArquivoRecebido from "./componentes/ArquivoRecebido/ArquivoRecebido";
import ListaArquivos from "../ListaArquivos/ListaArquivos";
import { TIPOS_ARQUIVOS } from "../ListaArquivos/TiposArquivos/TiposArquivosEnum";

export default {
  components: {
    ArquivoRecebido,
    JustificativaVazia,
    ListaArquivos
  },
  props: {
    listaArquivos: {
      type: Array,
      default: () => []
    },
    podeAprovarReprovar: {
      type: Boolean
    },
    codigoUnimed: {
      type: [String, Number]
    }
  },
  methods: {
    redirecionar() {
      this.$router.push("/administracao/unimeds/" + this.codigoUnimed);
    },
    aprovarArquivo(idArquivo) {
      this.$store.dispatch("setMostrarModalConfirmarResumido", {
        mostrarModalConfirmar: true,
        callbackModalConfirmar: () => {
          this.$emit("aprovar-arquivo", idArquivo);
          this.$store.commit("setMostrarModalConfirmar", false);
        },
        tituloModalConfirmar: "Deseja aprovar a exclusão \n do prestador?",
        mensagemModalConfirmar:
          "Ao aprovar a justificativa o prestador terá seu status alterado e será desativado na base de dados.",
        textoBotaoModalConfirmar: "SIM, APROVAR"
      });
    },
    reprovarArquivo(idArquivo) {
      this.$store.dispatch("setMostrarModalConfirmarResumido", {
        mostrarModalConfirmar: true,
        callbackModalConfirmar: () => {
          this.$emit("reprovar-arquivo", idArquivo);
          this.$store.commit("setMostrarModalConfirmar", false);
        },
        tituloModalConfirmar: "Deseja reprovar a justificativa?",
        mensagemModalConfirmar:
          "O prestador voltará ao status pendente e um novo arquivo será solicitado a singular.",
        textoBotaoModalConfirmar: "SIM, REPROVAR",
        tipoBotaoModalConfirmar: "importante"
      });
    }
  },
  computed: {
    mostrarJustificativaVazia() {
      return this.listaArquivos.length === 0;
    },
    mostrarArquivoRecebido() {
      return (
        this.listaArquivos.some(e => {
          return e.tipoArquivo === TIPOS_ARQUIVOS.ANALISE;
        }) && this.podeAprovarReprovar
      );
    },
    listaArquivosComputed() {
      if (this.podeAprovarReprovar) {
        return this.listaArquivos.filter(e => {
          return e.tipoArquivo !== TIPOS_ARQUIVOS.ANALISE;
        });
      }

      return this.listaArquivos;
    }
  }
};
</script>
